import React from "react";
import { Form, Input } from "antd";
import "./FormItem.scss";

const FormItemTextArea = ({
  name,
  label,
  rules,
  placeholder,
  rows = 3,
  maxLength = 500,
  className,
  disabled = false,
}) => {
  return (
    <Form.Item
      name={name}
      label={label}
      rules={rules}
      className={className}
    >
      <Input.TextArea
        size="large"
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default FormItemTextArea;
